import aboutUsLoadData from './pages/AboutUs/helpers/aboutUsPageData';
import auctionCalendarLoadData from './pages/AuctionCalendar/helpers/auctionCalendarPageData';
import auctionsNearMePageData from '@/pages/AuctionsNearMe/helpers/auctionsNearMePageData';
import biddingConsoleLoadData from './pages/BiddingConsole/helpers/biddingConsolePageData';
import catalogLoadData from './pages/Catalog/helpers/catalogPageData';
import catalogTermsLoadData from './pages/CatalogTerms/helpers/catalogTermsPageData';
import categoryLoadData from './pages/Search/CategorySearch/helpers/categorySearchData';
import collectionLoadData from './pages/CuratedCollection/helpers/curatedCollectionPageData';
import consignmentsLoadData from './pages/Consignments/helpers/consignmentsPageData';
import directoryLoadData from './pages/SellerDirectory/helpers/sellerDirectoryPageData';
import discoverCategoriesLoadData from './pages/DiscoverCategories/helpers/discoverCategoriesPageData';
import discoverLoadData from './pages/Discover/helpers/discoverPageData';
import favoritesAndFollowedPageData from './pages/FavoritesAndFollowed/helpers/favoritesAndFollowedPageData';
import featuredCatalogsLoadData from './pages/FeaturedCatalogs/helpers/featuredCatalogsPageData';
import flattenTheCurveLoadData from './pages/FlattenTheCurve/helpers/flattenTheCurvePageData';
import homeLoadData from './pages/Home/helpers/homePageData';
import itemLoadData from './pages/Item/helpers/itemPageData';
import loadable from '@loadable/component';
import messagesPageData from './pages/Messages/helpers/messagesPageData';
import messengerPageData from './pages/Messages/helpers/messengerPageData';
import myBidsLoadData from './pages/MyBids/helpers/myBidsPageData';
import ratingsLoadData from './pages/Ratings/helpers/ratingsPageData';
import recentItemsLoadData from './pages/RecentItems/helpers/recentItemsPageData';
import recommendedItemLoadData from './pages/RecommendedItem/helpers/recommendedItemPageData';
import reviewLoadData from './pages/Review/helpers/reviewPageData';
import searchLoadData from './pages/Search/helpers/searchPageData';
import sellerLoadData from './pages/Seller/helpers/sellerPageData';
import storefrontLoadData from './pages/Storefront/helpers/storeFrontPageData';
import wonItemsLoadData from './pages/WonItems/helpers/wonItemsPageData';

/**
 * Async codesplitting at the route level with @loadable-components
 * @see https://loadable-components.com/docs/dynamic-import/
 */
const ACHTermsAndConditions = loadable(() => import('./pages/TermsAndConditions/ACHTermsAndConditionsPage'));
const AboutUs = loadable(() => import('./pages/AboutUs/AboutUsPage'));
const AccountSettings = loadable(() => import('./pages/AccountSettings/AccountSettingsPageContainer'));
const AddCreditCard = loadable(() => import('./pages/AddCreditCard/AddCreditCardPage'));
const AuctionCalendar = loadable(() => import('./pages/AuctionCalendar/AuctionCalendarPageContainer'));
const AuctionResults = loadable(() => import('./pages/AuctionResults/AuctionResultsPage'));
const AuctionsNearMe = loadable(() => import('./pages/AuctionsNearMe/AuctionsNearMePage'));
const BiddingConsole = loadable(() => import('./pages/BiddingConsole/BiddingConsolePage'));
const Blocked = loadable(() => import('./pages/Blocked/BlockedByWaf'));
const Catalog = loadable(() => import('./pages/Catalog/CatalogPage'));
const CatalogTerms = loadable(() => import('./pages/CatalogTerms/CatalogTermsPage'));
const Category = loadable(() => import('./pages/Search/CategorySearch/CategorySearchPageContainer'));
const Checkout = loadable(() => import('./pages/Checkout/CheckoutPageContainer'));
const Collection = loadable(() => import('./pages/CuratedCollection/CuratedCollectionContainer'));
const Consignments = loadable(() => import('./pages/Consignments/ConsignmentsPageContainer'));
const CookiePolicy = loadable(() => import('./pages/Cookie/CookiePolicyPage'));
const Directory = loadable(() => import('./pages/SellerDirectory/SellerDirectoryPage'));
const Discover = loadable(() => import('./pages/Discover/DiscoverPage'));
const DiscoverCategories = loadable(() => import('./pages/DiscoverCategories/DiscoverCategories'));
const Features = loadable(() => import('./pages/Features/FeaturesPage'));
const FeaturedCatalogs = loadable(() => import('./pages/FeaturedCatalogs/FeaturedCatalogsPage'));
const FlattenTheCurve = loadable(() => import('./pages/FlattenTheCurve/FlattenTheCurvePage'));
const Home = loadable(() => import('./pages/Home/HomePage'));
const HowAuctionsWork = loadable(() => import('./pages/HowAuctionsWork/HowAuctionsWorkPage'));
const IntellectualProperty = loadable(() => import('./pages/IntellectualProperty/IntellectualPropertyPage'));
const Item = loadable(() => import('./pages/Item/ItemPage'));
const Messages = loadable(() => import('./pages/Messages/MessagesPage'));
const Messenger = loadable(() => import('./pages/Messages/MessengerPage'));
const MyAuctions = loadable(() => import('./pages/MyAuctions/MyAuctionsPageContainer'));
const MyBids = loadable(() => import('./pages/MyBids/MyBidsPageContainer'));
const NotFound = loadable(() => import('./pages/NotFound/NotFound'));
const Notifications = loadable(() => import('./pages/Notifications/NotificationsPage'));
const PRServices = loadable(() => import('./pages/PRServices/PRServicesPage'));
const PasswordReset = loadable(() => import('./pages/PasswordReset/PasswordResetPageContainer'));
const Privacy = loadable(() => import('./pages/Privacy/PrivacyPage'));
const Ratings = loadable(() => import('./pages/Ratings/RatingsPageContainer'));
const RecentlyViewed = loadable(() => import('./pages/RecentItems/RecentItemsPage'));
const RecommendedItem = loadable(() => import('./pages/RecommendedItem/RecommendedItemPage'));
const Review = loadable(() => import('./pages/Review/ReviewPageContainer'));
const SavedFavoritesAndFollowed = loadable(
    () => import('./pages/FavoritesAndFollowed/FavoritesAndFollowedPageContainer')
);
const Search = loadable(() => import('./pages/Search/SearchPageContainer'));
const Seller = loadable(() => import('./pages/Seller/SellerPageContainer'));
const SellerReviews = loadable(() => import('./pages/SellerReviews/SellerReviewsPage'));
const Storefront = loadable(() => import('./pages/Storefront/StorefrontPageContainer'));
const TaxCertCapture = loadable(() => import('./pages/TaxCertCapture/TaxCertCapturePage'));
const Terminology = loadable(() => import('./pages/Terminology/TerminologyPage'));
const TermsAndConditions = loadable(() => import('./pages/TermsAndConditions/TermsAndConditionsPage'));
const TermsAndConditionsPayments = loadable(() => import('./pages/TermsAndConditions/TermsAndConditionsPaymentsPage'));
// @ts-ignore the compose HOC doesn't return a good type, can remove once component is hooks based
const WonItems = loadable(() => import('./pages/WonItems/WonItemsPageContainer'));

/**
 * Application route config for react-router-config
 * Each route can optionally have an async loadData function to fetch data during SSR
 *
 * @see https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config#route-configuration-shape
 * @see https://reacttraining.com/react-router/web/guides/server-rendering/data-loading
 */
const routes = (isWhiteLabel: boolean) => [
    // https://localdev.liveauctioneers.com:3443/
    {
        ...(isWhiteLabel
            ? { component: Seller, loadData: sellerLoadData }
            : { component: Home, loadData: homeLoadData }),
        exact: true,
        path: '/',
    },

    // https://localdev.liveauctioneers.com:3443/about
    { component: AboutUs, exact: true, loadData: aboutUsLoadData, path: '/about' },

    // https://localdev.liveauctioneers.com:3443/auction-results
    { component: AuctionResults, exact: true, path: '/auction-results' },

    // Handle Blocked by Waf
    { component: Blocked, exact: true, path: '/blocked' },
    // https://localdev.liveauctioneers.com:3443/auctioneer/directory
    { component: Directory, exact: true, loadData: directoryLoadData, path: '/auctioneer/directory' },

    // https://localdev.liveauctioneers.com:3443/auctioneer/6341/cloudswood-auction
    { component: Seller, exact: true, loadData: sellerLoadData, path: '/auctioneer/:sellerId/:sellerName' },

    // https://localdev.liveauctioneers.com:3443/auctioneer/6341/cloudswood-auction/reviews
    { component: Ratings, exact: true, loadData: ratingsLoadData, path: '/auctioneer/:sellerId/:sellerName/reviews' },

    // https://localdev.liveauctioneers.com:3443/seller/6341
    { component: Storefront, exact: true, loadData: storefrontLoadData, path: '/seller/:sellerId' },

    // https://localdev.liveauctioneers.com:3443/c/
    { component: DiscoverCategories, exact: true, loadData: discoverCategoriesLoadData, path: '/c' },

    // https://localdev.liveauctioneers.com:3443/c/drawings/8/
    { component: Category, exact: true, loadData: categoryLoadData, path: '/c/:categoryName/:categoryId' },

    // https://localdev.liveauctioneers.com:3443/c/art/pablo-picasso/1/18755/
    {
        component: Category,
        exact: true,
        loadData: categoryLoadData,
        path: '/c/:categoryName/:categoryName2/:categoryId/:categoryId2',
    },

    // https://localdev.liveauctioneers.com:3443/console/154704_chinese-ceramics-and-works-of-art/
    { component: BiddingConsole, exact: true, loadData: biddingConsoleLoadData, path: '/console/:catalogId' },
    // TODO: fix

    // https://localdev.liveauctioneers.com:3443/featured/extraordinary-treasures/26
    {
        component: Collection,
        exact: true,
        loadData: collectionLoadData,
        path: '/featured/:collectionName/:collectionId',
    },

    // https://localdev.liveauctioneers.com:3443/price-guide
    { component: AuctionResults, exact: true, path: '/price-guide' },

    // https://localdev.liveauctioneers.com:3443/price-guide/drawings/8/
    {
        component: Category,
        exact: true,
        loadData: categoryLoadData,
        path: '/price-guide/:categoryName/:categoryId',
    },

    // https://localdev.liveauctioneers.com:3443/catalog/search
    { component: AuctionCalendar, exact: true, loadData: auctionCalendarLoadData, path: '/catalog/search' },

    // https://localdev.liveauctioneers.com:3443/catalog/search
    { component: Catalog, exact: true, loadData: catalogLoadData, path: '/catalog/:catalogId' },

    // https://localdev.liveauctioneers.com:3443/consignments
    { component: Consignments, exact: true, loadData: consignmentsLoadData, path: '/consignments' },

    // https://localdev.liveauctioneers.com:3443/consignments/6341
    { component: Consignments, exact: true, loadData: consignmentsLoadData, path: '/consignments/:sellerId' },

    // https://localdev.liveauctioneers.com:3443/cookie-policy
    { component: CookiePolicy, exact: true, path: '/cookie-policy' },

    // https://localdev.liveauctioneers.com:3443/features
    { component: Discover, exact: true, loadData: discoverLoadData, path: '/discover/:topic' },

    // https://localdev.liveauctioneers.com:3443/features
    { component: Features, exact: true, path: '/Features' },

    // https://localdev.liveauctioneers.com:3443/find-auctions-near-me
    { component: FeaturedCatalogs, exact: true, loadData: featuredCatalogsLoadData, path: '/featured-auctions' },

    // https://localdev.liveauctioneers.com:3443/find-auctions-near-me/
    { component: AuctionsNearMe, exact: true, loadData: auctionsNearMePageData, path: '/find-auctions-near-me/' },

    // https://localdev.liveauctioneers.com:3443/find-auctions-near-me/1/new-york-city/
    {
        component: AuctionsNearMe,
        exact: true,
        loadData: auctionsNearMePageData,
        path: '/find-auctions-near-me/:geoAreaId/:geoAreaName/',
    },

    // https://localdev.liveauctioneers.com:3443/find-auctions-near-me/1/new-york-city
    { component: FlattenTheCurve, exact: true, loadData: flattenTheCurveLoadData, path: '/flattenthecurve' },

    // https://localdev.liveauctioneers.com:3443/flattenthecurve/5584
    { component: FlattenTheCurve, exact: true, loadData: flattenTheCurveLoadData, path: '/flattenthecurve/:sellerId' },

    // https://localdev.liveauctioneers.com:3443/how-auctions-work
    { component: HowAuctionsWork, exact: true, path: '/how-auctions-work' },

    // https://localdev.liveauctioneers.com:3443/item/78040263_georgian-banded-mahogany-cellarette
    { component: Item, exact: true, loadData: itemLoadData, path: '/item/:itemId' },

    // https://localdev.liveauctioneers.com:3443/password_reset
    { component: PasswordReset, exact: true, path: '/password_reset' },
    {
        component: PasswordReset,
        exact: true,

        path: '/password_reset/:bidderId/:hash',
    },

    // https://localdev.liveauctioneers.com:3443/prservices
    { component: PRServices, exact: true, path: '/prservices' },

    // https://localdev.liveauctioneers.com:3443/privacy
    { component: Privacy, exact: true, path: '/privacy' },

    // https://localdev.liveauctioneers.com:3443/recent
    { component: RecentlyViewed, exact: true, loadData: recentItemsLoadData, path: '/recent' },

    // https://localdev.liveauctioneers.com:3443/search
    { component: Search, exact: true, loadData: searchLoadData, path: '/search' },

    // https://localdev.liveauctioneers.com:3443/seller-reviews
    { component: SellerReviews, exact: true, path: '/seller-reviews' },

    // https://localdev.liveauctioneers.com:3443/termsandconditionspayments
    {
        component: TermsAndConditionsPayments,
        exact: true,
        path: '/termsandconditionspayments',
    },

    // https://localdev.liveauctioneers.com:3443/termsandconditions
    { component: ACHTermsAndConditions, exact: true, path: '/achtermsandconditions' },

    // https://localdev.liveauctioneers.com:3443/achtermsandconditions
    { component: TermsAndConditions, exact: true, path: '/termsandconditions' },

    // https://localdev.liveauctioneers.com:3443/terms/154704_chinese-ceramics-and-works-of-art/
    { component: CatalogTerms, exact: true, loadData: catalogTermsLoadData, path: '/terms/:catalogId' },

    // https://localdev.liveauctioneers.com:3443/terminology
    { component: Terminology, exact: true, path: '/terminology' },

    // https://localdev.liveauctioneers.com:3443/intellectualproperty
    {
        component: IntellectualProperty,
        exact: true,
        path: '/intellectualproperty',
    },
    /**
     * Authenticated routes
     */
    { component: AccountSettings, exact: true, path: '/dashboard/profile' },
    { component: AddCreditCard, exact: true, path: '/dashboard/cardonfile' },
    {
        component: SavedFavoritesAndFollowed,
        exact: true,
        loadData: favoritesAndFollowedPageData,
        path: '/dashboard/followed-auctioneers',
    },
    { component: Messages, exact: true, loadData: messagesPageData, path: '/dashboard/messages' },
    { component: Messenger, exact: true, loadData: messengerPageData, path: '/dashboard/messages/:conversationId' },
    { component: MyBids, exact: true, loadData: myBidsLoadData, path: '/dashboard/my-bids' },
    { component: MyAuctions, exact: true, path: '/dashboard/my-auctions' },
    {
        component: Notifications,
        exact: true,

        path: '/dashboard/emails-and-notifications',
    },
    {
        component: SavedFavoritesAndFollowed,
        exact: true,
        loadData: favoritesAndFollowedPageData,
        path: '/dashboard/search-and-alerts',
    },
    { component: Review, exact: true, loadData: reviewLoadData, path: '/review/:catalogId' },
    { component: SavedFavoritesAndFollowed, loadData: favoritesAndFollowedPageData, path: '/dashboard/saved-items' },
    { component: Checkout, exact: true, path: '/checkout/:catalogId' },
    { component: WonItems, exact: true, loadData: wonItemsLoadData, path: '/dashboard/won-items' },
    { component: RecommendedItem, exact: true, loadData: recommendedItemLoadData, path: '/recommended' },
    { component: RecommendedItem, exact: true, loadData: recommendedItemLoadData, path: '/recommended/:amazon' },
    { component: TaxCertCapture, exact: true, path: '/certcapture' },
    /**
     * Handle 404 pages
     */
    { component: NotFound, exact: true, path: '/not-found' },
    { component: NotFound },
];

export default routes;
